import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ApiToken,
  ApiTokenCreationParams,
  ApiTokensListParams
} from '~core/models/api-token.models';
import { Pagination } from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class ApiTokenService {
  private readonly _http = inject(HttpClient);
  private readonly _apiConstantsService = inject(ApiConstantsService);

  list(params?: ApiTokensListParams): Observable<Pagination<ApiToken>> {
    return this._http.get<Pagination<ApiToken>>(
      this._apiConstantsService.apiTokensUrl,
      { params }
    );
  }

  read(apiTokenId: string): Observable<ApiToken> {
    return this._http.get<ApiToken>(
      `${this._apiConstantsService.apiTokensUrl}/${apiTokenId}`
    );
  }

  create(payload: ApiTokenCreationParams): Observable<ApiToken> {
    return this._http.post<ApiToken>(
      this._apiConstantsService.apiTokensUrl,
      payload
    );
  }

  update(
    apiTokenId: string,
    payload: Partial<ApiTokenCreationParams>
  ): Observable<ApiToken> {
    return this._http.patch<ApiToken>(
      `${this._apiConstantsService.apiTokensUrl}/${apiTokenId}`,
      payload
    );
  }

  delete(apiTokenId: string): Observable<unknown> {
    return this._http.delete(
      `${this._apiConstantsService.apiTokensUrl}/${apiTokenId}`
    );
  }
}
